export const media = {
	phoneMaxWidth: 575,
};
